module.exports = __webpack_public_path__ + "static/img/storeM.e25405a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storeM.png
// module id = 2h+x
// module chunks = 1